import {useEffect} from 'react'
import {getTitle} from '../utils/title.utils'

export const useWebTitle = (title: string) => {
  useEffect(() => {
    document.title = getTitle(title)
  }, [title])
}
